module.exports = __webpack_public_path__ + "img/agreement.3107bb85.svg";